<div class="st-drawer-wrapper convert-lead-drawer">
  <a href=""></a>
  <!--  Header  -->
  <div class="st-drawer-header">
    <span class="text-header-18 text-semibold">Convertir en oportunidad</span>
    <app-st-icon
      (click)="close()"
      class="text-header-16 cursor-pointer"
      [name]="'close'"
      [bold]="true"
    ></app-st-icon>
  </div>

  <!--  Content  -->
  <div class="st-drawer-content">
    <form class="st-form" nz-form [formGroup]="convertForm">
      <!-- Tipo de Oportunidad -->
      <nz-form-item>
        <nz-form-label [nzSpan]="24" nzRequired>Tipo de Oportunidad</nz-form-label>
        <nz-form-control [nzErrorTip]="'Este campo es requerido'">
          <nz-select
            nzSize="large"
            formControlName="opportunityType"
            nzPlaceHolder="Seleccione tipo"
          >
            <nz-option nzValue="Proyecto" nzLabel="Proyecto"></nz-option>
            <nz-option nzValue="Servicio Puntual" nzLabel="Servicio Puntual"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <!-- Asignar esta oportunidad a -->
      <div style="margin-top: 24px;">
        <span class="assign-label">Asignar esta oportunidad a</span>

        <div nz-row [nzGutter]="16" style="margin-top: 16px;">
          <!-- Equipo de ventas (primero) -->
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Equipo de ventas</nz-form-label>
              <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                <nz-select
                  nzSize="large"
                  formControlName="salesTeam"
                  nzPlaceHolder="Seleccione equipo de ventas"
                >
                  <nz-option
                    *ngFor="let salesTeam of salesTeamList"
                    [nzValue]="salesTeam.id"
                    [nzLabel]="salesTeam.name"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Comercial (después del equipo) -->
          <div nz-col [nzXs]="24" [nzSm]="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Comercial</nz-form-label>
              <nz-form-control [nzErrorTip]="'Este campo es requerido'">
                <app-avatar-select
                  formControlName="commercial"
                  [options]="filteredCommercialList"
                  placeholder="Selecciona el Comercial..."
                ></app-avatar-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <!-- Centro de costo y Moneda -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Centro de costo</nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-select
                nzSize="large"
                formControlName="costCenter"
                nzPlaceHolder="Seleccione Centro de costo"
                nzShowSearch
                nzAllowClear
              >
                <nz-option
                  *ngFor="let costCenter of costCenterList"
                  [nzValue]="costCenter.id"
                  [nzLabel]="costCenter.name"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Moneda</nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-select
                nzSize="large"
                formControlName="currencyId"
                nzPlaceHolder="Seleccione moneda"
              >
                <nz-option
                  *ngFor="let currency of currencyList"
                  [nzValue]="currency.id"
                  [nzLabel]="currency.name"
                ></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>

      <!-- Cierre previsto -->
      <div nz-row [nzGutter]="16">
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" nzRequired>Cierre previsto</nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-input-group nzSize="large" class="addon-after" [nzAddOnAfter]="suffixTmpl">
                <nz-date-picker
                  nzSize="large"
                  [nzSuffixIcon]="emtySuffixTmpl"
                  class="w-100"
                  formControlName="expectedClosingDate"
                  nzPlaceHolder="Introduce fecha de cierre..."
                  nzFormat="dd-MM-yyyy"
                  [nzDisabledDate]="disabledPastDate"
                ></nz-date-picker>
              </nz-input-group>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
  </div>

  <!--  Footer  -->
  <div class="st-drawer-footer">
    <button
      nz-button
      nzType="text"
      nzShape="round"
      nzSize="large"
      (click)="discard()">
      Descartar
    </button>
    <button
      nz-button
      nzType="primary"
      nzShape="round"
      nzSize="large"
      [nzLoading]="converting"
      [disabled]="convertForm.invalid"
      (click)="convert()">
      Crear oportunidad
    </button>
  </div>
</div>

<!-- Template: Notificación Toast -->
<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor" [showUndo]="toastConfig.showUndo"
             [notRef]="notRef" [content]="toastConfig.content" [msg]="toastConfig.msg"></app-toast>
</ng-template>

<ng-template #emtySuffixTmpl>
</ng-template>

<ng-template #suffixTmpl>
  <app-st-icon style="font-size: 20px" color="#666666" [bold]="true" name="calendar_today"></app-st-icon>
</ng-template>

